$(document).on("hidden.bs.modal", function() {
  $(".enrollment-errors").html("").removeClass("alert alert-danger")
})
